// ABOUTME: Counts outgoing GraphQL operations by name, so a span can report how many it caused.
// ABOUTME: A link, because only the chain knows what actually left — including retries.

import { ApolloLink } from "@apollo/client"

/*
 * MULTI_ATHLETE_CALENDAR_PERF_SPEC R0.b asks a drag's span how many requirements requests it sent:
 * the chunked `basicRequirementsBatch` (21-63 of them before R1, and expected to be zero after it)
 * and the singular `getBasicRequirements`. Neither is visible from useDnd — they are fired by cells
 * and providers elsewhere — so the count is kept here and read as a difference across the operation.
 *
 * The link sits low in the chain, just above the terminal one, so what it counts is what actually
 * went out. A retry therefore counts twice, which is the point: after R1 a batch request during a
 * drag is a regression whether it was retried or not.
 */

const counts = new Map<string, number>()

export function createOperationCounterLink(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    const name = operation.operationName
    if (name) counts.set(name, (counts.get(name) ?? 0) + 1)
    return forward(operation)
  })
}

/** How many operations of this name have gone out since the tab was opened. */
export function operationCount(name: string): number {
  return counts.get(name) ?? 0
}

/** Test seam — the counter is module state and would otherwise leak between cases. */
export function resetOperationCountsForTests(): void {
  counts.clear()
}
